module.exports = __webpack_public_path__ + "static/media/icon-home-fill.12f7faef.svg";